import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import SelectorArchivos, { subirEnSerie, avisaResultado } from "../../SelectorArchivos";
import Header from "../../../layout/Header/Header";
import moment from "moment";
import * as XLSX from "xlsx";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

import { v4 as uuidv4 } from "uuid";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function OrdenesCompraCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_ORDENES_COMPRA = process.env.REACT_APP_URL_ORDENES_COMPRA;
  const URL_ARTICULOS_OC = process.env.REACT_APP_URL_ARTICULOS_OC;
  const URL_LINEAS = process.env.REACT_APP_URL_LINEAS;
  const URL_MARCAS = process.env.REACT_APP_URL_MARCAS;
  const URL_FAMILIAS = process.env.REACT_APP_URL_FAMILIAS;
  const URL_UNIDADES_NEGOCIO = process.env.REACT_APP_URL_UNIDADES_NEGOCIO;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [articulos, setArticulos] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [moneda, setMoneda] = useState("");
  const [requisicion, setRequisicion] = useState("");

  // Alta rapida de articulo nuevo sin salir de la orden
  const [modalArticulo, setModalArticulo] = useState(false);
  const toggleArticulo = () => setModalArticulo(!modalArticulo);
  const [lineas, setLineas] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [familias, setFamilias] = useState([]);
  const [unidades, setUnidades] = useState([]);
  const [nuevoSKU, setNuevoSKU] = useState("");
  const [nuevoNombre, setNuevoNombre] = useState("");
  const [nuevoCosto, setNuevoCosto] = useState(0);
  const [nuevoPiezasCaja, setNuevoPiezasCaja] = useState(1);
  const [nuevoLinea, setNuevoLinea] = useState("");
  const [nuevoMarca, setNuevoMarca] = useState("");
  const [nuevoFamilia, setNuevoFamilia] = useState("");
  const [nuevoUnidad, setNuevoUnidad] = useState("");
  const [guardandoArticulo, setGuardandoArticulo] = useState(false);

  // Archivos que se adjuntan a la orden (se suben cuando ya existe el folio)
  const [archivos, setArchivos] = useState([]);
  const [condicionesPago, setCondicionesPago] = useState("");
  // D06: % de anticipo; con el se calcula el monto sugerido de la solicitud de pago
  const [porcentajeAnticipo, setPorcentajeAnticipo] = useState("");

  const [fecha, setFecha] = useState(hoy);
  const [plazo, setPlazo] = useState("");
  const [fecha_compromiso, setFechaCompromiso] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [total_general, setTotalGeneral] = useState(0);
  const [total_cantidad, setTotalCantidad] = useState(0);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);
  const [totalCaptura, setTotalCaptura] = useState(1);

  const classes = useStyles();
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulos: "",
      cantidad: 0,
      precio: 0,
      total: 0,
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulos = res.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
    .get(`${URL_PROVEEDORES}`, { 
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allProveedores = res.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });

    // Catalogos para dar de alta un articulo nuevo desde la orden
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };
    const preselecciona = (lista, set) => {
      const na = lista.find((x) => String(x.name).toUpperCase() === "NA");
      if (na) set(na._id);
    };
    axios.get(URL_LINEAS, { headers }).then((r) => {
      setLineas(r.data || []);
      preselecciona(r.data || [], setNuevoLinea);
    }).catch((err) => console.log(err));
    axios.get(URL_MARCAS, { headers }).then((r) => {
      setMarcas(r.data || []);
      preselecciona(r.data || [], setNuevoMarca);
    }).catch((err) => console.log(err));
    axios.get(URL_FAMILIAS, { headers }).then((r) => {
      setFamilias(r.data || []);
      preselecciona(r.data || [], setNuevoFamilia);
    }).catch((err) => console.log(err));
    axios.get(URL_UNIDADES_NEGOCIO, { headers }).then((r) => {
      setUnidades(r.data || []);
      preselecciona(r.data || [], setNuevoUnidad);
    }).catch((err) => console.log(err));
  }, []);

  // Guarda el articulo nuevo y lo deja listo para usarse en la orden
  function guardaArticuloNuevo() {
    if (!selectedProveedor) {
      Swal.fire({ icon: "error", title: "Primero selecciona el proveedor de la orden" });
      return;
    }
    if (!nuevoSKU || !nuevoNombre) {
      Swal.fire({ icon: "error", title: "Captura el SKU y la descripcion" });
      return;
    }
    if (!nuevoLinea || !nuevoMarca || !nuevoFamilia || !nuevoUnidad) {
      Swal.fire({ icon: "error", title: "Falta linea, marca, familia o unidad de negocio" });
      return;
    }
    const repetido = articulos.find(
      (a) => String(a.SKU || "").trim().toLowerCase() === nuevoSKU.trim().toLowerCase()
    );
    if (repetido) {
      Swal.fire({
        icon: "error",
        title: "Ese SKU ya existe",
        text: `${repetido.SKU} ${repetido.nombre}. Buscalo en la lista de articulos.`,
      });
      return;
    }
    setGuardandoArticulo(true);
    const costo = parseFloat(nuevoCosto) || 0;
    axios
      .post(
        URL_ARTICULOS,
        {
          codigo: nuevoSKU.trim(),
          SKU: nuevoSKU.trim(),
          codigoSAT: "NA",
          nombre: nuevoNombre.trim(),
          modelo: "NA",
          piezasPorCaja: parseFloat(nuevoPiezasCaja) || 1,
          costoUSD: moneda == "USD" ? costo : 0,
          costoCNY: moneda == "CNY" ? costo : 0,
          costoMX: moneda == "MXN" ? costo : 0,
          venta: 0,
          observaciones: "Alta desde Orden de Compra",
          proveedores: selectedProveedor,
          lineas: nuevoLinea,
          marcas: nuevoMarca,
          familias: nuevoFamilia,
          unidadesNegocio: nuevoUnidad,
          EAN: "NA",
          SKUBase: "NA",
          MLM: "NA",
          ASIN: "NA",
          ASINAntiguo: "NA",
          imagenes: "NA",
          linkML: "NA",
          linkShein: "NA",
          linkAmazon: "NA",
          linkCoppel: "NA",
          linkLiverpool: "NA",
          linkWalmart: "NA",
          linkElektra: "NA",
          cargadoML: "No",
          cargadoShein: "No",
          cargadoAmazon: "No",
          cargadoCoppel: "No",
          cargadoWalmart: "No",
          cargadoLiverpool: "No",
          cargadoElektra: "No",
          especiales: "No",
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then((res) => {
        const creado = res.data;
        setArticulos([...articulos, creado]);
        axios.post(
          URL_LOGS,
          {
            tipo: "Crear Articulo",
            detalle: `${creado.SKU} desde Orden de Compra`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        setGuardandoArticulo(false);
        toggleArticulo();
        setNuevoSKU("");
        setNuevoNombre("");
        setNuevoCosto(0);
        setNuevoPiezasCaja(1);
        Swal.fire({
          icon: "success",
          title: "Articulo creado",
          text: `${creado.SKU} ya se puede seleccionar en los renglones. Completa el resto de su ficha despues, en Articulos.`,
        });
      })
      .catch((error) => {
        setGuardandoArticulo(false);
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "No se pudo crear el articulo",
          footer: `${error.response?.data?.message || error.response?.data || ""}`,
        });
      });
  }

  const saveOrdenCompra = async (event) => {
    event.preventDefault();
    setValidaBoton(false);
    toggleProgreso();

    let totalArticulos = inputFields.length;

    try {
      await axios
        .post(
          URL_ORDENES_COMPRA,
          {
            fecha,
            proveedores: selectedProveedor,
            total_general,
            total_cantidad,
            observaciones,
            embarcado: 0,
            moneda,
            requisicion,
            condicionesPago,
            porcentajeAnticipo: parseFloat(porcentajeAnticipo) || 0,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then((data) => {
          inputFields.map((a) => {
            axios
              .post(
                URL_ARTICULOS_OC,
                {
                  ordenesCompra: data.data._id,
                  articulos: a.articulos,
                  cantidad: parseFloat(a.cantidad),
                  embarcado: 0,
                  pendiente_embarcar: parseFloat(a.cantidad),
                  precio: parseFloat(a.precio),
                  total: parseFloat(a.total),
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                totalArticulos = totalArticulos - 1;
                if (totalArticulos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Crear Orden de Compra",
                        detalle: `${selectedProveedor} ${total_general}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(async () => {
                      // Los archivos se suben hasta aqui, cuando la orden ya tiene folio
                      if (archivos.length) {
                        const resultado = await subirEnSerie(
                          archivos,
                          (archivo, nombre) => {
                            const formData = new FormData();
                            formData.append("file", archivo);
                            formData.append("nombre", nombre);
                            formData.append("user", user.id);
                            return axios.post(`${URL_ORDENES_COMPRA}Archivo/${data.data._id}`, formData, {
                              headers: {
                                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                              },
                            });
                          },
                          "Orden creada · subiendo archivos"
                        );
                        if (resultado.fallidos.length) {
                          // Antes este aviso se tapaba con el de "Creado con exito" y nadie lo veia
                          await avisaResultado(
                            resultado,
                            ""
                          );
                          await Swal.fire({
                            icon: "info",
                            title: "La orden si se creo",
                            text: "Los archivos que fallaron los puedes subir desde el listado.",
                          });
                          window.location.reload();
                          return;
                        }
                      }
                      Swal.fire("Good job!", "Creado con exito", "success");
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                });
                console.log(error);
                setValidaBoton(true);
              });
          });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
          console.log(error);
          setValidaBoton(true);
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
      console.log(error);
    }
  };
  const handleAddFields = () => {
    const ultimo = inputFields[inputFields.length - 1];
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulos: ultimo.articulos,
        cantidad: 0,
        precio: ultimo.precio,
        total: 0,
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let cant = values.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TC);
    let importes = values.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setTotalGeneral(TG);
  };

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function BuscaArticulo(id, selectedArticulo) {
    let FOB 
    articulos.map((a) => {
      if (a._id == selectedArticulo._id) {

        let idArticulo = selectedArticulo._id;
        if (moneda == "CNY") {
          FOB = a.costoCNY;
        } else if (moneda == "MXN") {
          FOB = a.costoMX;
        } else {
          FOB = a.costoUSD;
        }
        handleChangeInputArticulo(id, idArticulo, FOB);
      }
    });
  }

  const handleChangeInputArticulo = (id, idArticulo, FOB) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.total = 0;
        i.precio = FOB;
        i.cantidad = 0;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function ActualizaTotales() {
    let cant = inputFields.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TC);
    let importes = inputFields.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setTotalGeneral(TG);
  }

  function jalaProveedor(proveedor) {
    setInputFields([
      {
        id: uuidv4(),
        articulos: "",
        cantidad: 0,
        precio: 0,
        total: 0,
      },
    ]);
    if (!proveedor) {
      setSelectedProveedor("");
      setMoneda("");
      return;
    }
    setSelectedProveedor(proveedor._id);
    // La moneda del proveedor es la sugerida; se puede cambiar en la orden
    setMoneda(proveedor.moneda || "USD");
  }

  // Opciones del buscador de proveedor: se escribe el nombre y filtra solo
  const optionsProveedores = proveedores
    .filter((p) => p.is_active !== "No")
    .map((option) => {
      const junta = `${option.codigo || ""} ${option.nombre_comercial || ""} ${option.razon_social || ""}`.trim();
      const primera = String(option.nombre_comercial || option.codigo || "?")[0].toUpperCase();
      return {
        firstLetter: /[0-9]/.test(primera) ? "0-9" : primera,
        ...option,
        junta,
      };
    });

  const options = articulos.map((option) => {
    const junta = option.SKU + option.nombre;
    const firstLetter = option.SKU[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

//     function importarArchivo(event){
//    const target = event.target;
//    const value = target.type === "checkbox" ? target.checked : target.value;
//    const name = target.name;
//    let hojas = [];
  
//    if (name === "file") {
 
//      let reader = new FileReader();
//        reader.readAsArrayBuffer(target.files[0]);
//        reader.onloadend = (e) => {
//          var data = new Uint8Array(e.target.result);
//          var workbook = XLSX.read(data, { type: "array" });
 
//          workbook.SheetNames.forEach(function (sheetName) {
//            // Here is your object
//            var XL_row_object = XLSX.utils.sheet_to_json(
//              workbook.Sheets[sheetName]
//            );
//            hojas.push({
//              data: XL_row_object,
//              sheetName,
//            });
//          });
 
//          let A1 = hojas[0].data
 
//          let TC = totalCaptura
//          A1.map((a)=>{
//             TC = TC + 1
//            setTotalCaptura(TC)
//          inputFields.push({
//            id: uuidv4(),
//            articulos: a.articulos,
//           cantidad: a.cantidad,
//           precio: 0,
//           total: 0,
//           articulosNombre: a.articulosNombre
//          })
//          })
 
//          ActualizaTotales()
//        }
//    }
//  }
//  console.log("hola", inputFields)

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_oc ? (
        <div className="card container col-12">
          <h3 align="center">Nueva Orden de Compra</h3>
          <Form onSubmit={saveOrdenCompra}>
            <Row>
              <Col md={3}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha}
                  required
                  onChange={(e) => {
                    setFecha(e.target.value);
                  }}
                />
              </Col>
              <Col md={4}>
                <Label className="mr-sm-2">Proveedor</Label>
                <Autocomplete
                  size="small"
                  options={optionsProveedores.sort(
                    (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                  )}
                  groupBy={(option) => option.firstLetter}
                  getOptionLabel={(option) => option.junta}
                  onChange={(event, selectedProv) => {
                    jalaProveedor(selectedProv);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Escribe el nombre del proveedor"
                      variant="outlined"
                      onKeyDown={(e) => {
                        // Enter aqui elige de la lista, no manda el formulario
                        if (e.key === "Enter") e.preventDefault();
                      }}
                    />
                  )}
                  renderOption={(option) => (
                    <React.Fragment>
                      {option.codigo} {option.nombre_comercial} · {option.moneda}
                    </React.Fragment>
                  )}
                />
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Moneda</Label>
                <Input
                  type="select"
                  value={moneda}
                  required
                  onChange={(e) => setMoneda(e.target.value)}
                >
                  <option value="">Selecciona</option>
                  <option value="USD">USD</option>
                  <option value="CNY">CNY</option>
                  <option value="MXN">MXN</option>
                  <option value="EUR">EUR</option>
                </Input>
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                <Label className="mr-sm-2">Requisicion</Label>
                <Input
                  type="text"
                  placeholder="Numero de requisicion"
                  value={requisicion}
                  onChange={(e) => setRequisicion(e.target.value)}
                />
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">% Anticipo</Label>
                <Input
                  type="number"
                  min="0"
                  max="100"
                  step="any"
                  placeholder="Ej. 30"
                  title="Porcentaje del total que se paga de anticipo. Con el se calcula el monto de la solicitud de pago"
                  value={porcentajeAnticipo}
                  onChange={(e) => {
                    const v = e.target.value;
                    if (v === "" || (parseFloat(v) >= 0 && parseFloat(v) <= 100)) setPorcentajeAnticipo(v);
                  }}
                />
                {parseFloat(porcentajeAnticipo) > 0 ? (
                  <small style={{ color: "#64748b" }}>
                    {"$" + new Intl.NumberFormat("en-US").format(((total_general || 0) * parseFloat(porcentajeAnticipo)) / 100)}
                  </small>
                ) : null}
              </Col>
              <Col md={5}>
                <Label className="mr-sm-2">Condiciones de pago</Label>
                <Input
                  type="text"
                  placeholder="Ej. 30% anticipo, 70% contra copia de BL"
                  value={condicionesPago}
                  onChange={(e) => setCondicionesPago(e.target.value)}
                />
              </Col>
            </Row>
            <Row>
             
              <Col md={10}>
                <h4 id="logoutBoton">
                  TOTALES {total_cantidad} pzas. /{" "}
                  {"$" + new Intl.NumberFormat("en-US").format(total_general)}
                </h4>
              </Col>
            </Row>

            {/* <Row>

            <Col>
                    <Input
                      required
                      type="file"
                      name="file"
                      id="file"
                      onChange={(event) =>
                        importarArchivo(event)
                      }
                    />
                    </Col>
            </Row> */}

            {/* Tabla Articulos */}

            <Row>
              <Col md={5}>
                <Label className="mr-sm-2">Articulos</Label>{" "}
                <Button
                  size="sm"
                  color="info"
                  onClick={toggleArticulo}
                  tabindex="-1"
                  title="Dar de alta un articulo que no esta en el catalogo"
                >
                  <i class="fas fa-plus"></i> Articulo nuevo
                </Button>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Precio {moneda}</Label>
              </Col>
              
              <Col md={2}>
                <Label className="mr-sm-2">Total</Label>
              </Col>
            </Row>

            {inputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={5}>
                    <Autocomplete
                      size="small"
                      value={inputField.articulosNombre}
                      onChange={(event, selectedArticulo) => {
                        BuscaArticulo(inputField.id, selectedArticulo);
                      }}
                      options={options.sort(
                        (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                      )}
                      groupBy={(option) => option.firstLetter}
                      getOptionLabel={(option) => option.junta}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Selecciona"
                          variant="outlined"
                        />
                      )}
                      renderOption={(option) => (
                        <React.Fragment>
                          {option.SKU} {option.nombre}
                        </React.Fragment>
                      )}
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="cantidad"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Cantidad"
                      value={inputField.cantidad}
                      required
                      onChange={(event) =>
                        handleChangeInput(inputField.id, event)
                      }
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="precio"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Precio"
                      value={inputField.precio}
                      required
                      onChange={(event) =>
                        handleChangeInput(inputField.id, event)
                      }
                    />
                  </Col>

                  <Col md={2}>
                    <Input
                      // bsSize="sm"
                      name="total"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Total"
                      value={inputField.total}
                      disabled
                      onChange={(event) =>
                        handleChangeInput(inputField.id, event)
                      }
                    />
                  </Col>
                  <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFields}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}
            <Row>
              <Col md={6}>
                <Label className="mr-sm-2">
                  Archivos de la orden (proforma, cotizacion, lo que necesites)
                </Label>
                <SelectorArchivos archivos={archivos} onChange={setArchivos} />
                {!archivos.length ? (
                  <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 4 }}>
                    Opcional. Se guardan al crear la orden y se consultan despues desde el listado.
                  </div>
                ) : null}
              </Col>
            </Row>
            <br />
            <Row>
            <Col md={6}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="textarea"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
              <Col md={4}>
                <h4 id="logoutBoton">
                  TOTALES {total_cantidad} pzas. /{" "}
                  {"$" + new Intl.NumberFormat("en-US").format(total_general)}
                </h4>
              </Col>
            </Row>
            {/* Termina Tabla Articulos */}

            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/ListadoOrdenesCompra"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />
          <Modal size="lg" isOpen={modalArticulo} toggle={toggleArticulo}>
            <ModalHeader toggle={toggleArticulo}>
              <h4>Articulo nuevo</h4>
            </ModalHeader>
            <ModalBody>
              <div style={{ fontSize: 12, color: "#64748b" }}>
                Se crea con lo minimo para poder comprarlo. El resto de la ficha
                (medidas, pesos, ligas de marketplaces) se completa despues en
                Articulos.
              </div>
              <br />
              <Row>
                <Col md={4}>
                  <Label className="mr-sm-2">SKU</Label>
                  <Input
                    type="text"
                    placeholder="SKU"
                    value={nuevoSKU}
                    onChange={(e) => setNuevoSKU(e.target.value)}
                  />
                </Col>
                <Col md={8}>
                  <Label className="mr-sm-2">Descripcion</Label>
                  <Input
                    type="text"
                    placeholder="Descripcion del articulo"
                    value={nuevoNombre}
                    onChange={(e) => setNuevoNombre(e.target.value)}
                  />
                </Col>
              </Row>
              <br />
              <Row>
                <Col md={4}>
                  <Label className="mr-sm-2">Costo {moneda}</Label>
                  <Input
                    type="number"
                    min="0"
                    step="any"
                    value={nuevoCosto}
                    onChange={(e) => setNuevoCosto(e.target.value)}
                  />
                </Col>
                <Col md={4}>
                  <Label className="mr-sm-2">Piezas por caja</Label>
                  <Input
                    type="number"
                    min="1"
                    step="any"
                    value={nuevoPiezasCaja}
                    onChange={(e) => setNuevoPiezasCaja(e.target.value)}
                  />
                </Col>
              </Row>
              <br />
              <Row>
                <Col md={3}>
                  <Label className="mr-sm-2">Linea</Label>
                  <Input
                    type="select"
                    value={nuevoLinea}
                    onChange={(e) => setNuevoLinea(e.target.value)}
                  >
                    <option value="">Selecciona</option>
                    {lineas
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => (
                        <option key={a._id} value={a._id}>
                          {a.name}
                        </option>
                      ))}
                  </Input>
                </Col>
                <Col md={3}>
                  <Label className="mr-sm-2">Marca</Label>
                  <Input
                    type="select"
                    value={nuevoMarca}
                    onChange={(e) => setNuevoMarca(e.target.value)}
                  >
                    <option value="">Selecciona</option>
                    {marcas
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => (
                        <option key={a._id} value={a._id}>
                          {a.name}
                        </option>
                      ))}
                  </Input>
                </Col>
                <Col md={3}>
                  <Label className="mr-sm-2">Familia</Label>
                  <Input
                    type="select"
                    value={nuevoFamilia}
                    onChange={(e) => setNuevoFamilia(e.target.value)}
                  >
                    <option value="">Selecciona</option>
                    {familias
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => (
                        <option key={a._id} value={a._id}>
                          {a.name}
                        </option>
                      ))}
                  </Input>
                </Col>
                <Col md={3}>
                  <Label className="mr-sm-2">Unidad de negocio</Label>
                  <Input
                    type="select"
                    value={nuevoUnidad}
                    onChange={(e) => setNuevoUnidad(e.target.value)}
                  >
                    <option value="">Selecciona</option>
                    {unidades
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => (
                        <option key={a._id} value={a._id}>
                          {a.name}
                        </option>
                      ))}
                  </Input>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button
                color="success"
                onClick={guardaArticuloNuevo}
                disabled={guardandoArticulo}
              >
                {guardandoArticulo ? "Guardando..." : "Guardar articulo"}
              </Button>
              <Button color="danger" onClick={toggleArticulo}>
                Cancelar
              </Button>
            </ModalFooter>
          </Modal>

          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default OrdenesCompraCreate;
